import { isPlainObject, set } from "es-toolkit/compat";

/**
 * The reverse of the flattenObject function. Given object with `dot noation`
 * properties, returns an object with nested properties e.g.
 *   { a: 1, "b.c": 2, "b.d": 3} => { a: 1, b: { c: 2, d: 3 }
 *
 * pickListProperties have their values expanded to { id: value, name: value }
 *  e.g. with pickListProperties = ["b.c"],
 *   { a: 1, "b.c": 2, "b.d": 3} => { a: 1, b: { c: { id: 2 }, d: 3 } }
 *
 * @param {Object.<string, any>} object The object with "dot notation" properties
 *   expanded to { id: value, name: value }
 */
export const toExpandedObject = (
  object: Record<string, any>
): Record<string, any> => {
  const result: Record<string, any> = {};

  Object.entries(object).forEach(([key, value]) => {
    set(result, key, isPlainObject(value) ? toExpandedObject(value) : value);
  });

  return result;
};
